import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { ISmsVerifyProps } from "./smsCodeDialog";
import useLanguagesHooks from "../../../../../../../../Components/Languages/setLanguage-hooks";
import { INewOrder } from "../../../../../../../../Interfaces/request-interfaces";
import { useResendSmsMutation, useVerifySmsMutation } from "../../../../../../../../API/authApi";
import OrderSuccess from "../OrderSuccess/orderSuccess";

const useSmsVerification = (props: ISmsVerifyProps) => {
    const { data, setDialog, setMainCart, setContentType, onCloseDialog } = props;
    const { control, getValues, setError, handleSubmit,watch } = useForm<{ code: string }>({ mode: 'all' });
    const code = watch('code');
    const [verifyCode, { data: response, isLoading, isSuccess, isError }] = useVerifySmsMutation();
    const [resendCode, { data: resendResponse, isSuccess: resendSuccess }] = useResendSmsMutation();
    const [secondsLeft, setSecondsLeft] = useState<number>(60);
    const [canResend, setCanResend] = useState<boolean>(false);
    const [verifyError, setVerifyError] = useState<string | null>(null);
    const isValid = code && code.length === 4;
    console.log(isValid,'isvalid')
    console.log(verifyError,'verifyError')
    const { t } = useLanguagesHooks();

    useEffect(() => {
        let interval: NodeJS.Timeout | null = null;
        if (!canResend && secondsLeft > 0) {
            interval = setInterval(() => {
                setSecondsLeft(prev => {
                    if (prev <= 1) {
                        clearInterval(interval!);
                        setCanResend(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => {
            if (interval) clearInterval(interval);
        };
    }, [canResend, secondsLeft]);


    const onResendCode = () => {
        resendCode({ phone_number: data.phone_number })
        setCanResend(false);
    };

    const onVerify = () => {
        const code = getValues('code');
        if (code && code.length === 4) {
            const payload: INewOrder = {
                ...data,
                sms_code: code
            };
            verifyCode(payload)
        } else {
            setError('code', { message: t('Errors.Code') })
        }
    };

    useEffect(() => {
        if (resendSuccess && resendResponse) {
            setSecondsLeft(60);
            setCanResend(false);
            setVerifyError(null)
        }
    }, [resendSuccess, resendResponse]);

    useEffect(() => {
        if (isSuccess && response) {
            setMainCart([]);
            setDialog(
                <OrderSuccess
                    setContentType={setContentType}
                    onClose={onCloseDialog}
                />)
            localStorage.setItem('user_id', response.user_uuid);
            localStorage.setItem('phone', data.phone_number)
        } else if (isError) {
            setVerifyError(t('Errors.SMS'))
        }
    }, [isSuccess, isError]);

    return {
        isValid,
        control,
        isLoading,
        canResend,
        secondsLeft,
        verifyError,
        onVerify,
        onResendCode,
        handleSubmit,
        setCanResend,
        setSecondsLeft,
    }
};

export default useSmsVerification